module.exports = __webpack_public_path__ + "img/Wien junior.45ea4829.jpg";